import axios from './axios'
import { bbsApi } from '@/utils/http'
import { merge } from 'lodash-es'
import { promoteUrl } from "@/utils/url";

/**
 * 接口範例
 */
let testAPI = (data) => {
  return bbsApi({ data, 'mod': 'test', 'action': 'trace' })
}

/**
 * init(目前只有存cookie=> palcode、refurl)
 */
export const initAPI = (get) => {
  return bbsApi({ get, 'mod': 'init', 'action': 'index' })
}

/**
 * 取得公告
 */
export const getAnnouncementListAPI = (data) => {
  data.showError = false // 有错误不显示提示
  return bbsApi({ data, 'mod': 'announcement', 'action': 'list' })
}

/**
 * 取得fid模块下的帖子列表
 * @param { String } fid 模块id
 * @param { Number } page 第一页，由1开始
 * @param { Number } page_size 一页多少比数据
 * @param { String } option 筛选条件：'top'：置顶, 'tuijian'：推荐, 'digest'：精华, 'new'：最新
 */
export const getForumListAPI = (data) => {
  return bbsApi({ data, 'mod': 'forum', 'action': 'list' })
}

/**
 * 取得熱榜帖子
 * @param {*} data
 * @returns
 */
export const getHotThreadsAPI = (data) => {
  return bbsApi({ data, 'mod': 'forum', 'action': 'get-hot-threads' })
}

/**
 * 根据话题下的帖子列表
 * @param { String } topic_id 欲搜寻的话题id
 * @param { Number } page 第一页，由1开始
 * @param { Number } page_size 一页多少比数据
 * @param { String } option hot=最热, new=最新
 */
export const getTopicPostsAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'search' })
}

/**
 * 轮播图
 */
export const getBannerListAPI = (data) => {
  return bbsApi({ data, 'mod': 'banner', 'action': 'list' })
}

/**
 * 取得影片
 */
export const getBannerVideoAPI = (data) => {
  return bbsApi({ data, 'mod': 'banner', 'action': 'video' })
}

/**
 * 取得用户资料 (需登入态)
 */
export const getUserInfoAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'info' })
}

/**
 * 取得导航相关
 */
export const getNavListAPI = (data) => {
  return bbsApi({ data, 'mod': 'nav', 'action': 'list' })
}

/**
 * 取得排行榜
 */
export const getRankingAPI = (data) => {
  return bbsApi({ data, 'mod': 'ranking', 'action': 'getwinner' })
}

/**
 * 取得话题排行榜
 */
export const getRankingTopicAPI = (data) => {
  return bbsApi({ data, 'mod': 'ranking', 'action': 'get-topic' })
}

/**
 * 取得排行榜(英雄、熱度、福米)
 */
export const getRankingWinnerAPI = (data) => {
  return bbsApi({ data, 'mod': 'ranking', 'action': 'getwinner' })
}

/**
 * 取得官網APP下載URL
 */
export const getInitDownloadAPI = (data) => {
  return bbsApi({ data, 'mod': 'init', 'action': 'download' })
}

/**
 * 取得任務資訊
 */
export const getTaskListAPI = params =>
  axios.post(promoteUrl() + '/home.php?mod=task_ajax&a=list&v=vue', params)

/**
 * 进行每日签到
 */
export const applySignIn = params =>
  axios.post(promoteUrl() + '/home.php?mod=task_ajax&a=draw&id=1&v=vue', params)

/**
 * 取得推荐码資訊
 */
export const getPalcodeInfoAPI = params =>
  axios.post(promoteUrl() + '/home.php?mod=ajax&a=palcode&v=vue', params)

/**
 * 更新用户资料，包含昵称、性别、简介，请使用表单方式传送以下内容
 */
export const updateSpaceProfileAPI = params => {
  let formData = new FormData() // 用formData的方式處理這接口
  for (const key in params) {
    formData.append(key, params[key])
  }
  return axios.post(promoteUrl() + '/home.php?mod=spacecp&ac=profile&op=base&v=vue', formData)
}

/**
 * 上傳大頭照
 */
export const uploadAvatarAPI = (data) => {
  return bbsApi({ data, 'mod': 'other', 'action': 'upload' })
}

/**
 * 提交推荐码
 * @param { String } parent_palcode 推荐码
 */
export const applyPalcodeAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'applypalcode' })
}

/**
 * 推薦關注
 * @param {*} data
 */
export const recommendFollowAPI = (data) =>{
  return bbsApi({ data, 'mod': 'user', 'action': 'recommend-follow' })
}

/**
 * 我的发帖
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const getMyThreadAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'getmythread' })
}

/**
 * 我的回复
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const getMyReplyAPI = (data) =>  {
  return bbsApi({ data, 'mod': 'user', 'action': 'getmypost' })
}

/**
 * 我的打赏
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const getMyDonateAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'getmydonate' })
}

/**
 * 我的收藏
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const getMyFavoriteAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'getmyfavorite' })
}


/**
 * 我关注的用户
 * @param { String } page 页码
 * @param { String } page_size 一頁几笔
 */
export const getMyFollowedUserAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'my-follow-user' })
}

/**
 * 我关注的话题
 * @param { String } page 页码
 * @param { String } page_size 一頁几笔
 */
export const getMyFollowedTopicAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'get-my-follow' })
}


/**
 * 私人消息
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const gePersonalNoticeAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'getnotice', 'type': 'post' })
}

/**
 * 系统消息
 * @param { String } page 页码
 * @param { String } perpage 一頁几笔
 */
export const getSystemNoticeAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'getnotice', 'type': 'system' })
}

/**
 * 私人/系统 未读消息总数量
 * @param { String } type post/system
 */
export const geUnreadNoticeTotalAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'countnewnotice' })
}

/**
 * 消息删除
 * @param { String } type byid/byuid
 * @param { String } id [ byid: 按消息id删除, byuid: 按用户id删除 ] 可多个用 , 区隔
 */
export const delNoticeAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'delnotice' })
}

/**
 * 消息标记已读
 * @param { String } type post/system
 * @param { String } id 可多个用 , 区隔; 空值的话为全部标记为已读
 */
export const changeNoticeStatusAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'changeNoticeStatus' })
}

/**
 * 关注用户
 * @param { String | Number } fuid 用户 id
 */
export const followUserAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'follow-user' })
}

/**
 * 取消关注用户
 * @param { String | Number } fuid 用户 id
 */
export const cancelFollowUserAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'cancel-follow-user' })
}

/**
 * 关注话题
 * @param { String | Number } topic_id 话题 id
 */
export const followTopicAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'follow' })
}

/**
 * 取消关注话题
 * @param { String | Number } topic_id 话题 id
 */
export const cancelFollowTopicAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'cancel-follow' })
}

/**
 * 取得此话题的最新用户
 * @param { String | Number } topic_id 话题 id
 */
export const getTopicFollowUserAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'get-join-user' })
}


/**
 * 创建话题
 * @param { String } name 话题名称
 * @param { String } pic_file 话题图片(base64格式)
 * @param { String } content 话题说明
 */
export const createTopicAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'create-topic' })
}


/**
 * 取得话题列表
 */
export const getTopicListAPI = (data) => {
  return bbsApi({ data, 'mod': 'topic', 'action': 'list' })
}

/**
 * 取得世界盃球料
 */
export const getWorldCupDataAPI = (data) =>{
  return bbsApi({ data, 'mod': 'activity', 'action': 'list' })
}
/**
 * 2022年度回憶
 */
export const getMemoriesAPI = (data) =>{
  return bbsApi({ data, 'mod': 'activity', 'action': 'get-memories' })
}
/**
 * 取得草稿箱列表
 */
export const getDraftBoxListAPI = (data) =>{
  return bbsApi({ data, 'mod': 'draftbox', 'action': 'list' })
}

/**
 * 删除草稿
 */
export const delDraftAPI = (data) => {
  return bbsApi({ data, 'mod': 'draftbox', 'action': 'del-draft' })
}
/**
 * 取得我的/ Ta 的粉丝
 * @params { Number } ta_uid Ta的uid
 */
export const getFollowerUserAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'get-my-fans' })
}
/**
 * 移除粉丝
 * @params { Number } ta_uid 要移除的uid
 */
export const removeFollowerAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'del-fans' })
}

/**
 * 取得今日評論最高的帖子
 */
export const searchHotThreadAPI = (data) => {
  return bbsApi({ data, 'mod': 'search', 'action': 'hot-thread' })
}

/**
 * 搜尋帖子主題
 */
export const searchThreadListAPI = (data) => {
  return bbsApi({ data, 'mod': 'search', 'action': 'thread-list' })
}

/**
 * 搜尋用戶
 */
export const searchNameListAPI = (data) => {
  return bbsApi({ data, 'mod': 'search', 'action': 'name-list' })
}

/**
 * 取得後台設定的官網domain
 */
export const getOfficialDomainAPI = (data) => {
  return bbsApi({ data, 'mod': 'other', 'action': 'office-domain' })
}


/**
 * 我的賬單
 */
export const getUserBillLogAPI = (data) => {
  return bbsApi({ data, 'mod': 'user', 'action': 'bill-log' })
}